import XLSX from "xlsx";
import FileSaver from 'file-saver';

export function downloadDriverShipmentListDetailsExcel(dataForExcel) {

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    let driverShipmentDetailsList = []

    if (dataForExcel.shipmentSettlementDetailList && dataForExcel.shipmentSettlementDetailList.length === 0) {
        driverShipmentDetailsList.push({
            trackingId: null,
            shipmentType: null,
            status: null,
            updateDate: null,
            paymentMethod: null,
            receivableAmount: null,
            receivedAmount: null,
        });
    } else {
        driverShipmentDetailsList = dataForExcel.shipmentSettlementDetailList.map(list => {
            return {
                trackingId: list.barcode || "NA",
                shipmentType: list.shipmentType || "NA",
                status: list.shipmentStatus || "NA",
                updateDate: list.updateDate || "NA",
                paymentMethod: list.paymentMethod || "NA",
                receivableAmount: list.receivableAmount? list.receivableAmount.value : "NA",
                receivedAmount: list.receivedAmount? list.receivedAmount.value : "NA",
            }
        });
    }

    const driverShipmentDetailsSheet = driverShipmentDetailsList;

    //Prepare xlsx output
    var today = new Date();
    var date = '-'+(today.getMonth()+1)+'-'+today.getDate()+'_'+today.getHours() + "_" + today.getMinutes();
    const fileName = "driverShipmentDetailsList-"+date;

    const driverShipmentDetailsSheetName = "Driver Shipment Details";
    const workBook = {SheetNames: [], Sheets: {}};
    const driverShipmentDetailsWorkSheet = XLSX.utils.json_to_sheet(driverShipmentDetailsSheet);

    workBook.SheetNames.push(driverShipmentDetailsSheetName);
    workBook.Sheets[driverShipmentDetailsSheetName] = driverShipmentDetailsWorkSheet;


    const excelBuffer = XLSX.write(workBook, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], {type: fileType});

    /* the saveAs call downloads a file on the local machine */
    FileSaver.saveAs(data, fileName + fileExtension);
}


// WEBPACK FOOTER //
// ./src/component/modal/driverReconciliation/driverShipmentDetailExcelDownload.js